import React, { useEffect, useState } from "react";
import { OrderViewContext } from "./OrderViewContext";
import ObjectDataHolder from "../Hooks/ObjectDataHolder";
import FilterSectionOrderView from "./FilterSectionOrderView";
import TableSectionOrderView from "./TableSectionOrderView";
import tableCalc from "../../utils/tableCalc";
import "../AccountingCoding/BalanceSheet2/balacesheet2.scss";
import axios from "axios";
import { prefixUrl } from "../../utils/utilsData";
import { toast } from "react-toastify";
import OperatingColumn from "./OperatingColumn";
import utilsFunction from "../../utils/utilsFunction";
import TableButtons from "./TableButtons";
import PaymentStatus from "./PaymentStatus";

function TableOrderView(props) {
  const starterData = {
    filter: {
      startDate: "",
      endDate: "",
      paymentStatus: "all",
    },

    tableData: {
      columns: [],

      data: [],
    },
  };
  const [data, setData] = ObjectDataHolder(starterData);
  const [reload, setReload] = useState(1);

  const getData = async () => {
    const myFilter = JSON.stringify(data.filter);

    try {
      const response = await axios.get(
        prefixUrl() + `/cartTable/?request=tableData&filter=${myFilter}`,
      );
      if (response.data.status) {
        let tableData = response.data;

        tableData.columns = tableData.columns.map((col) => {
          let myColumn = { ...col };
          myColumn.headerFilter = "input";

          myColumn.formatter = tableCalc.persianDigits;
          //myColumn.bottomCalc = tableCalc.sum
          myColumn.hasFilter = true;
          // myColumn.style ={
          // display:"flex",
          //   justifyContent:cen
          //   textAlign:"center"
          // }
          myColumn.style = {
            width: 160,
            minWidth: 160,
            maxWidth: 160,
            textAlign: "center",
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          };

          //console.log(col)
          if (col.field === "paymentStatus") {
            myColumn.formatter = (cell) => (
              <PaymentStatus setReload={setReload} cell={cell} />
            );
          }

          if (tableData.priceFields.includes(col?.field)) {
            myColumn.formatter = tableCalc.separateNumbers;
            myColumn.bottomCalc = tableCalc.sum;
          }

          return myColumn;
        });

        tableData.columns.push({
          title: "عملیات",
          formatter: (cell) => {
            return <OperatingColumn cell={cell} />;
          },
          style: {
            width: 150,
            minWidth: 150,
            maxWidth: 150,
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            overflow: "hidden",
          },
        });

        if (tableData.data && Array.isArray(tableData.data)) {
          const normalizeDate = (d) =>
            d
              .split("/")
              .map((p, i) => (i === 0 ? p : p.padStart(2, "0")))
              .join("/");

          tableData.data.sort((a, b) => {
            return (
              normalizeDate(b.orderDate).localeCompare(
                normalizeDate(a.orderDate),
              ) || b.orderId - a.orderId
            );
          });
        }

        setData({ tableData: tableData });
      } else {
        toast.error(response.data.message);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    void getData();
  }, [
    reload,
    data.filter.paymentStatus,
    data.filter.startDate,
    data.filter.endDate,
  ]);

  return (
    <OrderViewContext.Provider value={{ data, setData }}>
      <div className={"bg__white table__order__view "}>
        <FilterSectionOrderView />
        <TableSectionOrderView />
        <TableButtons />
      </div>
    </OrderViewContext.Provider>
  );
}

export default TableOrderView;
